export const getRawQueryParam = (search, name) => {
  const match = search.match(new RegExp(`[?&]${name}=([^&]*)`));
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
};
